export enum DiebstahlkennerStatus {
  IN_DELIVERY = 'modules.expert-tool.status-in-delivery',
  DELIVERED = 'modules.expert-tool.status-delivered',
  SCRAPPED = 'modules.expert-tool.status-scrapped',
  STOLEN = 'modules.expert-tool.status-stolen',
  IN_FINAL_ACCEPT = 'modules.expert-tool.status-in-final-accept',
  UNKNOWN = 'modules.expert-tool.status-unkown',
}
